export default __webpack_public_path__ + "static/media/arrow.aed6cad3.svg";